import React from 'react';
import { SOURCE_URL } from '../../../config';
import ReactMarkdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import gfm from 'remark-gfm';

interface SupportLinksWithThumbnailsProps {
    element: any
}

const SupportLinksWithThumbnails: React.FC<SupportLinksWithThumbnailsProps> = (element) => {

    const handleItems = (items: any) => {
        if(items){
            return Array.isArray(items) && items.map((item, index) =>(
                <div className={handleItemWidth(item?.ItemWidth)} key={index}>
                    <a className="thumbnail-wrap d-block" href={window.location.origin + "/support/" + item?.Link?.data?.attributes?.slug}>
                        <div className="img-wrap light-gray-bg d-flex align-items-center w-100 p-3">
                            <img src={SOURCE_URL + item?.Link?.data?.attributes?.FeaturedImage?.data?.attributes?.url} alt="" className="img-fluid mx-auto d-block" />
                        </div>
                        <span className="lg_font_size font-medium d-block text-center p-3">{item?.CustomTitle ? item?.CustomTitle : item?.Link?.data?.attributes?.Name}</span>
                    </a>
                </div>
            ))
        }
    }
    const handleItemWidth = (itemWidth : string) => {
        if(itemWidth == "Width: 1/2 of screen"){
            return "col-lg-6 half-width";
        }else if(itemWidth == "Width: 1/3 of screen"){
            return "col-lg-4 half-width";
        }else if(itemWidth == "Width: 1/4 of screen"){
            return "col-lg-3 fourth-width";
        }
    }

    return (
      <>
        <div className="links-with-thumbs container-fluid spacer-top">
            {element?.element?.Label ?
            <div className="thumbnails-links-label mb-4">
                <ReactMarkdown remarkPlugins={[gfm]} rehypePlugins={[rehypeRaw]}>{element?.element?.Label}</ReactMarkdown>
            </div>
            : <></>}
            <div className="row justify-content-center px-md-5 px-0 thumbnails-links">{handleItems(element?.element?.Items)}</div>
        </div>
      </>
    );
};

export default SupportLinksWithThumbnails;